export const diffArrays = (initialArray, newArray) => {
    const initialMap = new Map(initialArray.map(item => [item["Código"], item]));
    const newMap = new Map(newArray.map(item => [item["Código"], item]));

    const added = [];
    const removed = [];
    const modified = [];

    // Detectar agregados o modificados
    for (const [code, newItem] of newMap.entries()) {
        if (!initialMap.has(code)) {
            added.push(newItem);
        } else {
            const oldItem = initialMap.get(code);
            if (
                oldItem["Nombre"] !== newItem["Nombre"] ||
                oldItem["Código"] !== newItem["Código"] ||
                oldItem.pid !== newItem.pid ||
                oldItem.type !== newItem.type
            ) {
                modified.push({ before: oldItem, after: newItem });
            }
        }
    }

    // Detectar eliminados
    for (const [code, oldItem] of initialMap.entries()) {
        if (!newMap.has(code)) {
            removed.push(oldItem);
        }
    }

    return { added, removed, modified };
};